import React from 'react';
import PropTypes from 'prop-types';
import 'src/components/SlideBtnImg.scss';


const getImages = imgs => imgs.map(({ url, density }) => `${url} ${density}x`).join(', ');

const SlideButtonImage = ({
  url, linkTitle, img, altText
}) => (
  <div styleName="img-button-wrapper">
    <a key={ url } data-test="anchor-slider-slide" href={ url } title={ linkTitle }>
      <picture>
        <source
          key={ altText }
          data-test="img-src-set"
          srcSet={ getImages(img) }
        />
        <img
          alt={ altText }
          src={ img[0].url }
          styleName="slide-btn-img"
        />
      </picture>
    </a>
  </div>
);

SlideButtonImage.propTypes = {
  altText: PropTypes.string.isRequired,
  img: PropTypes.arrayOf(Object).isRequired,
  linkTitle: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default SlideButtonImage;
